import React, { useState, useRef, useEffect } from 'react'
import { Button } from 'antd'
import { string } from 'prop-types'

export function ExpandableDescription({ text }) {
	const [isExpanded, setIsExpanded] = useState(false)
	const [showButton, setShowButton] = useState(false)
	const textRef = useRef(null)

	useEffect(() => {
		// Check if the text actually overflows the 3-line container
		if (textRef.current) {
			const { scrollHeight, clientHeight } = textRef.current
			if (scrollHeight > clientHeight) {
				setShowButton(true)
			}
		}
	}, [text])

	const textStyle = isExpanded
		? {}
		: {
				display: '-webkit-box',
				WebkitLineClamp: 3,
				WebkitBoxOrient: 'vertical',
				overflow: 'hidden',
				whiteSpace: 'pre-wrap',
			}

	return (
		<div>
			<div ref={textRef} style={textStyle}>
				{text}
			</div>
			{showButton && (
				<Button
					type="link"
					size="small"
					style={{ padding: 0, marginTop: 8 }}
					onClick={() => setIsExpanded(!isExpanded)}>
					{isExpanded ? 'Mostrar menos' : 'Mostrar mais'}
				</Button>
			)}
		</div>
	)
}

ExpandableDescription.propTypes = {
	text: string,
}
